<template>
  <div class="zhaoBiaoDaiLi">
    <!-- 面包屑 -->
    <bread-crumb>
      <el-breadcrumb-item to="/home">首页</el-breadcrumb-item>
      <el-breadcrumb-item v-if="type == 2">政府采购</el-breadcrumb-item>
      <el-breadcrumb-item v-if="type == 1">招标信息</el-breadcrumb-item>
    </bread-crumb>
    <div class="contBox">
      <div class="leftMenu">
        <ul v-if="type == 1">
          <li
            :class="{ active: cur == index }"
            v-for="(item, index) in Arr"
            :key="item"
            @click="getServiceList(index)"
          >
            {{ item }}
          </li>
        </ul>
        <ul v-if="type == 2">
          <li
            :class="{ active: cur == index }"
            v-for="(item, index) in Arr2"
            :key="item"
            @click="getZhaobiaoList(index)"
          >
            {{ item }}
          </li>
        </ul>
      </div>
      <div class="carouselList">
        <div
          class="carouselItem"
          @click="toDetail(item.unitguid)"
          v-for="item in List"
          :key="item.unitguid"
        >
          <div>
            <img src="~@/assets/img/yuandian_icon.png" />
            <span>{{ item.title }}</span>
          </div>
          <div>{{ item.adddate }}</div>
        </div>
        <div class="nodata" v-show="List.length == 0">
          <img src="~@/assets/img/nodata.png" />
          <span>暂无数据~</span>
        </div>
        <!-- 分页 -->
        <pagination
          :pagedata="pageData"
          v-show="List.length > 0"
        ></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getList } from "@/api/index.js";
export default {
  name: "ZhaoBiaoDaiLi",
  data() {
    return {
      cur: 0,
      Arr: [
        "招标公告",
        "资格预审公告",
        "中标候选人公示",
        "中标结果公示",
        "更正公告",
      ],
      Arr2: ["采购信息", "采购结果", "更正公告"],
      serviceMethods: [
        "getZhaoBiaoGongGaoList",
        "getZiGeYuShenList",
        "getHouXuanRenGongShiList",
        "getZhongBiaoResultGongShiList",
        "getGengZhengGongGaoList",
      ],
      zhaoBiaoMethods: [
        "getZhaoBiaoGongGaoList",
        "getZhongBiaoResultGongShiList",
        "getGengZhengGongGaoList",
      ],
      pageData: {
        currentPage: 1,
        pageSize: 10, //一页放几行数据
        total: 0,
      },
      List: [],
      arrIndex: "",
      type: "",
      serviceStyle: [
        "getZhaoBiaDetail",
        "getZiGeYuShenDetail",
        "getHouXuanRenGongShiDetail",
        "getZhongBiaoJieGuoDetail",
        "getGengZhengGongGaoDetail",
      ],
      zhaoBiaoStyle: [
        "getZhaoBiaDetail",
        "getZhongBiaoJieGuoDetail",
        "getGengZhengGongGaoDetail",
      ],
    };
  },
  mounted() {
    this.type = this.$route.query.type;
    if (this.type == 1) {
      this.getServiceList(0);
    } else {
      this.getZhaobiaoList(0);
    }
  },
  watch: {
    "$route.query.type"(val) {
      this.type = val;
      if (this.type == 1) {
        this.pageData.currentPage = 1;
        this.getServiceList(0);
      } else {
        this.pageData.currentPage = 1;
        this.getZhaobiaoList(0);
      }
    },
    pageData: {
      deep: true,
      immediate: true,
      handler(val) {
          if(this.type==1){
            this.pageData.currentPage = val.currentPage;
            this.getServiceList(this.cur);
          }else if(this.type==2){
            this.pageData.currentPage = val.currentPage;
            this.getZhaobiaoList(this.cur);
          }
      }
    }
  },
  methods: {
    getServiceList(index) {
      if(this.cur != index){
        this.cur = index;
        this.pageData.currentPage=1
      }
      this.arrIndex = index;
      let page = this.pageData.currentPage;
      let Data = {
        pageIndex: page,
        pageSize: this.pageData.pageSize,
        ztbTenantID: this.$store.state.ztbTenantID,
        projectType: 1,
      };
      let method = this.serviceMethods[index];
      getList(method, Data).then((res) => {
        this.List = res.data.rows ? res.data.rows : [];
        this.pageData.total = res.data.total;
        this.pageData.currentPage = page ? page : 1;
        let data = res.data.rows;
        data.forEach((item) => {
          item.unitguid = item.unitguid ? item.unitguid : [];
          item.adddate = item.adddate?item.adddate.substring(0,10):item.faBuDate.substring(0,10);
          if(item.noticeName){
            item.title = item.noticeName;
          }else if(item.gongGaoTitle){
            item.title = item.gongGaoTitle;
          }else if(item.gongGaoName){
            item.title = item.gongGaoName;
          }
        });
      });
    },

    getZhaobiaoList(index) {
      if(this.cur != index){
        this.cur = index;
        this.pageData.currentPage=1
      }
      this.arrIndex = index;
      let page = this.pageData.currentPage;
      let Data = {
        pageIndex: page,
        pageSize: this.pageData.pageSize,
        ztbTenantID: this.$store.state.ztbTenantID,
        projectType: 2,
      };
      let method = this.zhaoBiaoMethods[index];
      getList(method, Data).then((res) => {
        this.List = res.data.rows ? res.data.rows : [];
        this.pageData.total = res.data.total;
        this.pageData.currentPage = page ? page : 1;
        let data = res.data.rows;
        data.forEach((item) => {
          item.unitguid = item.unitguid ? item.unitguid : [];
          item.adddate = item.adddate?item.adddate.substring(0,10):item.faBuDate.substring(0,10);
          if(item.noticeName){
            item.title = item.noticeName;
          }else if(item.gongGaoTitle){
            item.title = item.gongGaoTitle;
          }else if(item.gongGaoName){
            item.title = item.gongGaoName;
          }
        });
      });
    },

    toDetail(unitguid) {
      if(this.type==1){
        let style = this.serviceStyle[this.arrIndex];
        let routeUrl = this.$router.resolve({
          name: "ZBDLDetailInfo",
          query: {
            unitguid: unitguid,
            style,
            type: 1,
          },
        });
        window.open(routeUrl.href, '_blank');
        // this.$router.push({
        //   name: "ZBDLDetailInfo",
        //   query: {
        //     unitguid: unitguid,
        //     style,
        //     type: 1,
        //   },
        // });
      }else{
        let style = this.zhaoBiaoStyle[this.arrIndex];
        let routeUrl = this.$router.resolve({
          name: "ZBDLDetailInfo",
          query: {
            unitguid: unitguid,
            style,
            type: 2,
          },
        });
        window.open(routeUrl.href, '_blank');
        // this.$router.push({
        //   name: "ZBDLDetailInfo",
        //   query: {
        //     unitguid: unitguid,
        //     style,
        //     type: 2,
        //   },
        // });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.zhaoBiaoDaiLi {
  min-height: calc(100vh - 140px);
  .contBox {
    width: 1200px;
    margin: 0 auto;
    min-height: calc(100vh - 171px);
    padding: 20px 0;
    display: flex;
    justify-content: space-between;
    .leftMenu {
      width: 220px;
      background: $color-F7F9FA;
      ul {
        display: flex;
        flex-direction: column;
        height: 100%;
        li {
          width: 220px;
          height: 44px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          &:hover {
            background: $theme-color;
            color: $color-white;
            border: none;
          }
        }
      }
      .active {
        background: $theme-color;
        color: $color-white;
      }
    }
    .carouselList {
      width: 960px;
      border: 1px solid $border-color-EBEBEB;
      .carouselItem {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        height: 48px;
        border-bottom: 1px solid $border-color-EBEBEB;
        cursor: pointer;
        &:hover {
          color: $theme-color;
        }
        div {
          &:first-child {
            flex: 1;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            img {
              width: 4px;
              margin-right: 8px;
            }
          }
          &:last-child {
            color: $color-9;
            margin-left: 8px;
          }
        }
      }
      .nodata {
        position: absolute;
        top: 52%;
        left: 50%;
        // transform: translate(-50%,-50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        span {
          color: $color-9;
          padding-top: 8px;
        }
      }
    }
  }
  .paginationBox {
    width: 960px;
    padding: 20px;
    text-align: right;
  }
}
</style>
